import {
    ACCOUNT_LOGIN,
    VERIFY_TOKEN,
    GET_DASHBOARD_DATA,
    GET_ALL_CAGURA_USER,
    ADMIN_USER_DELETE_ITEM,
    ADMIN_USER_GET_USERS,
    ADMIN_USER_ADD_NEW,
    ADMIN_USER_UPDATE,
    SAVE_PERMISSION_ITEM,
    ADMIN_GET_PERMSSION_LIST,
    ADMIN_CHANGE_PERMSSION,
    USER_CUSTOMER_GET_ALL,
    ADMIN_USER_GET_ACCOUNT_OVERVIEW,
    ADMIN_USER_FUNDS_OVERVIEW,
    ADMIN_USER_GET_SUBSCRIPTION_REPORT,
    ADMIN_USER_STREAMING_REPORT,
    ADMIN_USER_UPDATE_INFO,
    USER_GET_INFORMATION,
    ADMIN_USER_TRANSATION_REPORT,
    ADMIN_USER_DOWNLOAD_TRANSATION_REPORT,
    ADMIN_USER_UPDATE_PERMISSIONS,
    ADMIN_USER_SAVE_WEBSITE_THEME,
    ADMIN_USER_GET_WEBSITE_THEME,
    ADMIN_USER_RESET_WEBSITE_THEME,
    ADMIN_USER_TOGGLE_LANDING_PAGE,
    ADMIN_USER_REGISTER_WEB_DOMAIN,
    ADMIN_USER_CONFIG_WEB_SSL,
    ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG,
    ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE,
    ADMIN_USER_GENERATE_STREAMING_TICKETS,
    ADMIN_USER_GENERATE_EVENT_TICKETS,
    ADMIN_USER_DOWNLOAD_FREE_TICKETS,
    ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE,
    ADMIN_USER_UPDATE_PASSWORD,
    ADMIN_GATEKEEPER_ADD_NEW,
    ADMIN_GATEKEEPER_UPDATE,
    ADMIN_GATEKEEPER_GET_ALL,
    ADMIN_GATEKEEPER_DELETE,
    ADMIN_TICKET_SELLER_GET_ALL,
    ADMIN_TICKET_SELLER_DELETE,
    ADMIN_TICKET_SELLER_ADD_NEW,
    ADMIN_TICKET_SELLER_UPDATE,
    STREAMER_USER_GENERATE_CHANNEL_API_KEY,
    STREAMER_USER_GET_CHANNEL_API_KEY
} from "../actions/user";

import {
    API_BASE_URL,
    ACCOUNT_LOGIN_URL,
    VERIFY_TOKEN_URL,
    GET_DASHBOARD_DATA_URL,
    GET_ALL_CAGURA_USER_URL,
    ADMIN_USER_DELETE_ITEM_URL,
    ADMIN_USER_GET_USERS_URL,
    ADMIN_USER_ADD_NEW_URL,
    ADMIN_USER_UPDATE_URL,
    SAVE_PERMISSION_ITEM_URL,
    ADMIN_GET_PERMSSION_LIST_URL,
    ADMIN_CHANGE_PERMSSION_URL,
    USER_CUSTOMER_GET_ALL_URL,
    ADMIN_USER_GET_ACCOUNT_OVERVIEW_URL,
    ADMIN_USER_FUNDS_OVERVIEW_URL,
    ADMIN_USER_GET_SUBSCRIPTION_REPORT_URL,
    ADMIN_USER_STREAMING_REPORT_URL,
    ADMIN_USER_UPDATE_INFO_URL,
    USER_GET_INFORMATION_URL,
    ADMIN_USER_TRANSATION_REPORT_URL,
    ADMIN_USER_DOWNLOAD_TRANSATION_REPORT_URL,
    ADMIN_USER_UPDATE_PERMISSIONS_URL,
    ADMIN_USER_SAVE_WEBSITE_THEME_URL,
    ADMIN_USER_GET_WEBSITE_THEME_URL,
    ADMIN_USER_RESET_WEBSITE_THEME_URL,
    ADMIN_USER_TOGGLE_LANDING_PAGE_URL,
    ADMIN_USER_REGISTER_WEB_DOMAIN_URL,
    ADMIN_USER_CONFIG_WEB_SSL_URL,
    ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG_URL,
    ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE_URL,
    ADMIN_USER_GENERATE_STREAMING_TICKETS_URL,
    ADMIN_USER_GENERATE_EVENT_TICKETS_URL,
    ADMIN_USER_DOWNLOAD_FREE_TICKETS_URL,
    ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE_URL,
    ADMIN_USER_UPDATE_PASSWORD_URL,
    ADMIN_GATEKEEPER_ADD_NEW_URL,
    ADMIN_GATEKEEPER_UPDATE_URL,
    ADMIN_GATEKEEPER_GET_ALL_URL,
    ADMIN_GATEKEEPER_DELETE_URL,
    ADMIN_TICKET_SELLER_GET_ALL_URL,
    ADMIN_TICKET_SELLER_DELETE_URL,
    ADMIN_TICKET_SELLER_ADD_NEW_URL,
    ADMIN_TICKET_SELLER_UPDATE_URL,
    STREAMER_USER_GENERATE_CHANNEL_API_KEY_URL,
    STREAMER_USER_GET_CHANNEL_API_KEY_URL,
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [ADMIN_TICKET_SELLER_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_TICKET_SELLER_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_TICKET_SELLER_DELETE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_TICKET_SELLER_DELETE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_TICKET_SELLER_ADD_NEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_TICKET_SELLER_ADD_NEW_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_TICKET_SELLER_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_TICKET_SELLER_UPDATE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_GATEKEEPER_DELETE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_GATEKEEPER_DELETE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_GATEKEEPER_ADD_NEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_GATEKEEPER_ADD_NEW_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_GATEKEEPER_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_GATEKEEPER_UPDATE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_GATEKEEPER_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_GATEKEEPER_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_UPDATE_PASSWORD]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_UPDATE_PASSWORD_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_DOWNLOAD_FREE_TICKETS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_DOWNLOAD_FREE_TICKETS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GENERATE_EVENT_TICKETS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GENERATE_EVENT_TICKETS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GENERATE_STREAMING_TICKETS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GENERATE_STREAMING_TICKETS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_REGISTER_WEB_DOMAIN]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_REGISTER_WEB_DOMAIN_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_CONFIG_WEB_SSL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_CONFIG_WEB_SSL_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_TOGGLE_LANDING_PAGE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_TOGGLE_LANDING_PAGE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_RESET_WEBSITE_THEME]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_RESET_WEBSITE_THEME_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GET_WEBSITE_THEME]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GET_WEBSITE_THEME_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_SAVE_WEBSITE_THEME]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_SAVE_WEBSITE_THEME_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_UPDATE_PERMISSIONS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_UPDATE_PERMISSIONS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_DOWNLOAD_TRANSATION_REPORT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_DOWNLOAD_TRANSATION_REPORT_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_TRANSATION_REPORT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_TRANSATION_REPORT_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [USER_GET_INFORMATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + USER_GET_INFORMATION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_UPDATE_INFO]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_UPDATE_INFO_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_STREAMING_REPORT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_STREAMING_REPORT_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GET_SUBSCRIPTION_REPORT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GET_SUBSCRIPTION_REPORT_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_FUNDS_OVERVIEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_FUNDS_OVERVIEW_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GET_ACCOUNT_OVERVIEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GET_ACCOUNT_OVERVIEW_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [USER_CUSTOMER_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + USER_CUSTOMER_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_CHANGE_PERMSSION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_CHANGE_PERMSSION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_GET_PERMSSION_LIST]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_GET_PERMSSION_LIST_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SAVE_PERMISSION_ITEM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SAVE_PERMISSION_ITEM_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_DELETE_ITEM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_DELETE_ITEM_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_GET_USERS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_GET_USERS_URL,
            method: "GET",
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_ADD_NEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_ADD_NEW_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ADMIN_USER_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADMIN_USER_UPDATE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [GET_ALL_CAGURA_USER]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + GET_ALL_CAGURA_USER_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [GET_DASHBOARD_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + GET_DASHBOARD_DATA_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [VERIFY_TOKEN]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VERIFY_TOKEN_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [ACCOUNT_LOGIN]: ({ commit, dispatch }, payload) => {
        return axios({
            url: API_BASE_URL + ACCOUNT_LOGIN_URL,
            method: "POST",
            data: payload,
        });
    },
    [STREAMER_USER_GENERATE_CHANNEL_API_KEY]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMER_USER_GENERATE_CHANNEL_API_KEY_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [STREAMER_USER_GET_CHANNEL_API_KEY]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMER_USER_GET_CHANNEL_API_KEY_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};